import { render } from "./InvoicePaymentPage.vue?vue&type=template&id=5da275d8"
import script from "./InvoicePaymentPage.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__